<template>
  <div class="user-container">
    <!-- 查询条件 -->
    <div class="search-form">
      <el-form :model="queryParams" inline>
        <el-form-item label="用户名">
          <el-input
            v-model="queryParams.username"
            placeholder="请输入用户名"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="queryParams.phone"
            placeholder="请输入手机号"
            clearable
            style="width: 180px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 数据表格 -->
    <div class="content-wrapper">
      <div class="table-toolbar">
        <span class="page-title">用户管理</span>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd">新增用户</el-button>
      </div>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="username" label="用户名" min-width="120" align="center" />
        <el-table-column prop="realName" label="真实姓名" min-width="120" align="center" />
        <el-table-column prop="phone" label="手机号" min-width="130" align="center" />
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.status === 1 ? 'success' : 'danger'" size="small">
              {{ row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="roleNames" label="角色" min-width="150" align="center">
          <template slot-scope="{ row }">
            <el-tag
              v-for="role in (row.roleNames || [])"
              :key="role"
              size="mini"
              style="margin-right: 4px"
              type="info"
            >
              {{ role }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="small" v-if="row.username !== 'admin'" @click="handleResetPwd(row)">重置密码</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" v-if="row.username !== 'admin'" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <Pagination
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <UserForm
      :visible.sync="formVisible"
      :form-data="formData"
      @success="getList"
    />
  </div>
</template>

<script>
import { getUserList, deleteUser, resetUserPassword } from '@/api/user'
import Pagination from '@/components/Pagination/index.vue'
import UserForm from './userForm.vue'

export default {
  name: 'UserManage',
  components: { Pagination, UserForm },
  data() {
    return {
      queryParams: {
        username: '',
        phone: '',
        pageNum: 1,
        pageSize: 10
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      formVisible: false,
      formData: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取用户列表
    getList() {
      this.tableLoading = true
      getUserList(this.queryParams).then(res => {
        // 后端返回纯数组 Result<List<SysUser>>，兼容分页格式
        const data = res.data
        if (Array.isArray(data)) {
          this.tableData = data
          this.total = data.length
        } else {
          this.tableData = data.records || data.list || []
          this.total = data.total || 0
        }
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.tableLoading = false
      })
    },

    // 查询
    handleSearch() {
      this.queryParams.pageNum = 1
      this.getList()
    },

    // 重置
    handleReset() {
      this.queryParams = {
        username: '',
        phone: '',
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },

    // 新增用户
    handleAdd() {
      this.formData = null
      this.formVisible = true
    },

    // 编辑用户
    handleEdit(row) {
      this.formData = { ...row }
      this.formVisible = true
    },

    // 重置密码
    handleResetPwd(row) {
      this.$prompt('请输入新密码', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{6,}$/,
        inputErrorMessage: '密码长度不能少于6位'
      }).then(({ value }) => {
        resetUserPassword({ userId: row.id, newPassword: value }).then(() => {
          this.$message.success('密码重置成功')
        })
      }).catch(() => {})
    },

    // 删除用户
    handleDelete(row) {
      this.$confirm('确定要删除该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteUser(row.id).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.user-container {
  height: 100%;
}
</style>
